var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorOctagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset=ErrorOctagon, colour=Error, htmlTag=img, assetKey=Content, state=Default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "report",
    d: "M12.8295 17C13.1129 17 13.3504 16.9042 13.542 16.7125C13.7337 16.5208 13.8295 16.2833 13.8295 16C13.8295 15.7167 13.7337 15.4792 13.542 15.2875C13.3504 15.0958 13.1129 15 12.8295 15C12.5462 15 12.3087 15.0958 12.117 15.2875C11.9254 15.4792 11.8295 15.7167 11.8295 16C11.8295 16.2833 11.9254 16.5208 12.117 16.7125C12.3087 16.9042 12.5462 17 12.8295 17ZM11.8295 13H13.8295V7H11.8295V13ZM9.07952 21L3.82952 15.75V8.25L9.07952 3H16.5795L21.8295 8.25V15.75L16.5795 21H9.07952Z",
    fill: "#FF5343"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorOctagon);
export default __webpack_public_path__ + "static/media/ErrorOctagon.cfc0caa40556808d410987c0bbcaf3bb.svg";
export { ForwardRef as ReactComponent };